(() => {
  if (window.__videoTipsInit) return;
  window.__videoTipsInit = true;

  let active = null;

  const stopActive = () => {
    if (!active) return;
    active.wrapper.remove();
    active.facade.style.display = '';
    active = null;
  };

  const playVideo = (facade) => {
    const id = facade.getAttribute('data-video-id');
    if (!id) return;

    stopActive();

    const wrapper = document.createElement('div');
    wrapper.className = 'video-tips__embed';

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
    iframe.title = facade.getAttribute('aria-label') || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    wrapper.appendChild(iframe);

    facade.style.display = 'none';
    facade.insertAdjacentElement('afterend', wrapper);
    active = { facade, wrapper };
  };

  const initSection = (root) => {
    if (!root || root.dataset.videoTipsReady === 'true') return;
    root.dataset.videoTipsReady = 'true';

    root.addEventListener('click', (event) => {
      const facade = event.target.closest('.video-tips__facade');
      if (facade && root.contains(facade)) playVideo(facade);
    });
  };

  const init = () => {
    document
      .querySelectorAll('[data-section-type="video-tips"]')
      .forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="video-tips"]');
    if (section) initSection(section);
    stopActive();
  });
})();